var r=function(e,t){return{value:e,done:t}};export{r as default};
